<template>
  <div class="cover-dialog dialog">
    <el-dialog v-bind="dialogProps" @close="cancelCover" @open="onOpenDialog" :close-on-click-modal="false">
      <div class="dialog__header" slot="title">
        选取封面
        <div class="dialog__close" @click="close()">
          <i class="icon-popup-close"></i>
        </div>
      </div>

      <div class="dialog__body">
        <div class="cropper-wrapper" :style="wrapperStyle" style="position: relative;">
          <cropper
            v-if="isShowCoverDialog && customCover && !url"
            ref="cropper"
            :src="getObjectURL(customCover)"
            v-bind="cropperProps"
          ></cropper>

          <div
            class="crop-size"
            v-show="cropSize.cropWidth && cropSize.cropHeight"
            style="position: absolute;"
            :style="{top: cropSize.top + 'px', left: cropSize.left + 'px'}"
          >{{cropSize.cropWidth + 'x' + cropSize.cropHeight}}</div>
        </div>
      </div>

      <div class="dialog__footer" slot="footer">
        <div class="btns-wrapper">
          <div class="cancel button--secondary" @click="close()">取消</div>
          <div class="submit button--primary" @click="confirmCover()">确定</div>
        </div>
      </div>
    </el-dialog>
  </div>
</template>

<script>
import { mapGetters } from "vuex";
import cropper from "../../topnav/cropper.vue";
const qiniuAssetsUrl = "https://resources.laihua.com";

export default {
  components: {
    cropper,
  },
  props: {
    visible: Boolean,
    coverType: String,
  },
  data() {
    return {
      // cropperProps: {
      //   autoCrop: true,
      //   // 只有自动截图开启 宽度高度才生效
      // 	autoCropWidth: 600,
      // 	autoCropHeight: 337.5,
      // 	// 开启宽度和高度比例
      // 	// fixed: true,
      // 	fixedNumber: [16, 9]
      // },
      url: "",
      blob: "",
      scene: "",
      cropperProps: {
        autoCropArea: 1,
        aspectRatio: 16 / 9,
        autoCrop: true,
        dragMode: "move",
        containerStyle: {
          width: "600px",
          height: "337.5px",
        },
        checkCrossOrigin: false,
        guides: false,
        center: false,

        // events
        ready: this.onVueCropReady,
        crop: this.onCrop,
        // cropend: this.onCropEnd,
      },
      canClearCover: true,
      wrapperStyle: {
        width: "600px",
        height: "337.5px",
      },
      maxWH: {
        width: 600,
        height: 337.5,
      },
      cropSize: {
        left: 0,
        top: 0,
        cropWidth: 0,
        cropHeight: 0,
      },
    };
  },
  computed: {
    dialogProps() {
      let { visible } = this;

      return {
        visible,
        width: "800px",
        "modal-append-to-body": false,
        "show-close": false,
        top: "60px",
      };
    },
    ...mapGetters(["TopnavMsg", "CacheCover", "TOOL"]),
    ...mapGetters({
      cover: "Cover",
      isShowCoverDialog: "subtitleExport/isShowCoverDialog",
      customCover: "subtitleExport/customCover",
    }),
    myUrl() {
      return this.url || this.TopnavMsg.cover.url;
    },
  },

  created() {
    this.$bus.on("coverDialog.initUrl", (val, blob, scene) => {
      if (this.coverType === "video") {
        return;
      }
      this.initUrl(val, blob, scene);
    });
  },

  methods: {
    initUrl(val, blob, scene) {
      this.url = val;
      this.blob = blob;
      this.scene = scene;
    },
    getObjectURL(blob) {
      if (!blob) {
        return;
      }
      return window.URL.createObjectURL(blob);
    },
    close() {
      this.$store.commit("subtitleExport/showCoverDialog", false);
    },
    onOpenDialog() {
      this.canClearCover = true;

      if (this.TOOL && this.TOOL.optimized === "Vertical") {
        this.$set(this.cropperProps, "aspectRatio", 9 / 16);
      } else {
        this.$set(this.cropperProps, "aspectRatio", 16 / 9);
      }
    },
    confirmCover() {
      this.$refs.cropper
        .getCroppedCanvas({
          width: this.cropSize.cropWidth,
          height: this.cropSize.cropHeight,
        })
        .toBlob((data) => {
          if (data.size > 10 * 1024 * 1024) {
            this.$message({
              type: "error",
              message: "截取的封面已经超出10MB限制",
            });
            return;
          }

          this.canClearCover = false;
          this.close();
          let coverPic = {
            url: window.URL.createObjectURL(data),
            blob: data,
          };
          this.$emit("confirm", data);
          this.$store.commit("subtitleExport/setCustomCover", data);
        });
    },
    uploadCover(data) {
      let urlapi = "/api/upload/file";
      let formData = new FormData();
      formData.append("files[]", data);
      return this.$http({
        url: urlapi,
        method: "post",
        data: formData,
      });
    },
    clearCover() {
      if (!this.canClearCover) {
        return;
      }
      this.$store.commit("save_Cover", {
        url: this.CacheCover.url,
        blob: this.CacheCover.blob,
        relativeUrl: this.CacheCover.relativeUrl,
      });
    },
    cancelCover() {
      this.close();
      this.clearCover();
      this.$refs.cropper.clear();
    },
    getWH(url) {
      let img = new Image();
      let myResolve;
      img.src = url;
      img.onload = () => {
        let { width, height } = img;
        myResolve({
          width,
          height,
        });
      };

      return new Promise((resolve, reject) => {
        myResolve = resolve;
      });
    },
    // 设置截图尺寸为容器尺寸
    setCropBoxData() {
      this.$refs.cropper.setCropBoxData({
        top: 0,
        left: 0,
        width: 600,
        height: 337.5,
      });
      this.$refs.cropper.crop();
    },
    setCropSize() {
      let { top, left, width, height } = this.$refs.cropper.getCropBoxData();
      // let { width, height } = this.$refs.cropper.getData();
      this.cropSize = {
        ...this.cropSize,
        top,
        left,
        cropWidth: Math.floor(width),
        cropHeight: Math.floor(height),
      };
    },
    onVueCropReady() {
      let containerData = this.$refs.cropper.getContainerData();
      let size = {
        width: 320,
        height: 180,
      };
      if (this.TOOL.optimized === "Vertical") {
        size = {
          width: 180,
          height: 320,
        };
        // this.$set(this.cropperProps, 'aspectRatio', 9 / 16)
      }
      this.$refs.cropper.setCropBoxData({
        top: containerData.height / 2 - size.height / 2,
        left: containerData.width / 2 - size.width / 2,
        width: size.width,
        height: size.height,
      });
      this.$refs.cropper.crop();

      this.setCropSize();
    },
    onCrop() {
      this.setCropSize();
    },
  },
};
</script>

<style lang="scss" scoped>
@import "../../../style/_colors.scss";

.dialog {
  &__close {
    display: flex;
    justify-content: center;
    align-items: center;
    position: absolute;
    top: 0;
    right: 0;
    width: 40px;
    height: 40px;
    cursor: pointer;
  }
  &__header {
    position: relative;
    height: 40px;
    line-height: 40px;
    background-color: $c8;
    border-radius: 4px 4px 0 0;
  }
  &__body {
    padding-left: 80px;
    padding-right: 80px;
    padding-top: 58px;
  }
  &__footer {
    padding-top: 46px;
    padding-bottom: 46px;
  }
}

.cropper-wrapper {
  width: 600px;
  height: 337.5px;
  margin: auto;

  .crop-size {
    background-color: rgba(#000, 0.5);
    color: #fff;
    padding: 2px 5px;
    transform: translate(0, -100%);
  }
}

.btns-wrapper {
  display: flex;
  justify-content: center;
}

.submit {
  width: 160px;
  height: 40px;
  border-radius: 8px;
  color: $c0;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
  background-color: #5778fb;
  &:hover {
    background-color: #7d95f5;
  }
}

.cancel {
  width: 160px;
  height: 40px;
  border-radius: 8px;
  text-align: center;
  line-height: 40px;
  cursor: pointer;
  margin-right: 100px;
  box-sizing: border-box;
  background-color: #eaeaf6;
  &:hover {
    background-color: #d8d8e9;
  }
}
</style>



// WEBPACK FOOTER //
// src/components/subtitle/subtitleExport/coverDialog.vue